<form [ngrxFormState]="form" *ngIf="form$|async; let form" class="w-100" autocomplete="off" role="presentation">

    <div class="content col-12 p-0">
        <h3 *ngIf="(isMobileVerified$ | async) == false">
            We've just sent you a text message with a
            verification code, enter it here
        </h3>
        <h3 *ngIf="(isMobileVerified$ | async) == true">
            {{ sendMobileCodeMessage$ | async }}
        </h3>
        <div class="row p-0">
            <div class="col col-md-12 p-0" *ngIf="(isMobileVerified$ | async) == false">
                <app-entry class="entry-dark-bg" title="Validation code" [control]="form.controls.mobileCode"
                    [autofill]="true" autocomplete="one-time-code">
                </app-entry>
                <div class="d-flex">
                    <a class="flex-fill click no-text-decoration" (click)="sendMobile(form.value.mobile)"
                        [ngClass]="{ locked: resendLocked == true }">Resend SMS to {{ form.value.mobile
                        }}
                        <span class="resend-time" *ngIf="resendLocked">({{ resendLockedTime }}
                            secs)</span></a>
                    <a style="text-align: end" class="flex-fill click no-text-decoration"
                        (click)="onMoveBackClick()">Change mobile number</a>
                </div>
            </div>
        </div>
    </div>
    <div class="card-bottom d-flex d-flex flex-row justify-content-between mt-3 mb-4 col-12 p-0">
        <app-button class="back-btn" title="Back" color="light" icon="west" [isDisabled]="(isLoading$ | async)" (onClick)="onMoveBackClick()">
        </app-button>
        <app-button class="custom" title="Next" [isDisabled]="(isLoading$ | async) || form.isInvalid" icon="east"
            loading (onClick)="
                                  onCheckMobileCodeClick(
                                    form,
                                    form.value.mobileCode
                                  )
                                ">
        </app-button>
    </div>
    <div class="footer footer-mobile col-12 mt-5 p-0">
        <ng-template class="" [ngTemplateOutlet]="FooterStep2"></ng-template>
    </div>
</form>

<ng-template #FooterStep2>
    <h5>
        Need help?
        <a href="https://vervesuper.com.au/contact-us/" target="_blank">Contact us.</a>
    </h5>
    <p>
        All information is of a general nature only. It is important to do your own
        research and consider things like fees, investment performance, insurance,
        risk, and alignment with your values when considering if Verve Super is
        right for you. Consider seeking financial advice. When considering
        performance, past performance is not indicative of future performance.
        <a href="https://vervesuper.com.au/fund-information/" target="_blank">Fund information.</a>
    </p>
</ng-template>